export var getMobileLineHeightClassName = function (lineHeight) {
    return "mlh-".concat(lineHeight);
};
//# sourceMappingURL=get-mobile-line-height-class-name.js.map